const Form014EN = {
    stepName: {
        importantNotes: "Important Notes",
        applicationInfo: "Application Information",
        confirmation: "Confirmation",
    },
    label: {
        title: {
            tips: "Application for Course Fee Refund to Teachers",
            tipsA: "School information",
        },
        selection: {
            schoolHead: "School head",
            teacher: "Teacher",
        },
        schoolHeadOption: {
            supervisor: "Supervisor",
            schoolHead: "School Head",
        },
        nameOfApplicant: "Name of Applicant",
        courseTitle: "Course Title",
        courseDuration: "Course Duration",
        courseStartDate: "Course start date",
        courseEndDate: "Course end date",
        courseFee: "Course Fee",
        refundAmountA: "Amount of Recommended Course Fee Refund",
        refundAmountATotal: "Total Amount of Recommended Course Fee Refund",
        name: "Name of Approver (Supervisor/School Head)",
        schoolRegistrationName: "School Registration Name",
        schoolRegistrationNo: "School Registration No.",
        accountPayee: "Account Payee (School Account only)",
        schoolRegistrationAddress: "School Registration Address",
        schoolEmailAddress: "School Email Address",
        telephoneNo: "Telephone No",
        faxNo: "Fax No",
        schoolHeadOrTeacher: "Applicant(s) for this application include(s)",
        supervisorOrschoolHead:
            "Approver (the person to sign and submit this application to Education Bureau)",
        supportDoc: "Supporting Documents",
        pisc: "Personal Information Collection Statement",
        declarationText: "Declaration (To be confirmed by the Approver)",
        declarationTextApprover1: "Declaration (",
        declarationTextApprover2:
            "Please read the following Declaration. Upon signing and submission of this application, you, as the Approver, are deemed to have made the following Declaration.",
        note: {
            note1: "I, as the <b>{{positionOne}}</b> of the serving school of the applicant(s), hereby sign to confirm that the <b>{{positionTwo}}</b> listed above has / have completed the course(s) which has / have met ALL the requirements set out in the Education Bureau Circular Memorandum <b>{{clauseText}}</b> dated <b>{{dateTime}}</b>. The <b>{{positionTwo}}</b> listed above has / have never received any public subsidy for the same course. ",
            note1A: " Original official receipts, and copies of transcripts, certificates and related documents",
            note1B: " issued by the course providers are kept properly at the school and are available for the Education Bureau's inspection at any time.",
            note2: "Total Amount (not exceeding HK${{totalAmount}})",
            note3: "Course fee refund is only applicable to course(s) completed between {{note1Start}} and {{note1End}}.",
        },
        importNotesList: {
            oneText:
                "Please study the Education Bureau Circular Memorandum {{clauseText}}- “Course Fee Refund to Teachers” for the details of the Application Procedures and Requirements.",
            twoText:
                "Upon completion of the course(s), Supervisor/School Head should submit the applications for course fee refund for their school head/teacher(s) between <b>{{periodText}}</b>.  <b>Late applications will not be entertained.</b>",
            threeText:
                "Schools are also required to keep records, including original official receipts, and copies of transcripts, certificates and related documents, of training course(s) taken by the school head/teacher(s) concerned properly.  These records should be made available for inspection by the Education Bureau at any time.",
            fourText:
                'If Supervisor/School Head, who acts as the approver for the application, has an "iAM Smart+" account with digital signing function, he/she can submit the application to the Education Bureau via this platform direct. Otherwise, Supervisor/School Head is required to download and submit the completed and signed application form to the Training and Development Team of the Education Bureau by fax or by post.',
        },
        refundRemark:
            "If there are 11 or more applicants applying for Course Fee Refund, you can tabulate and upload the details of all applications (i.e. Name of Applicant, Course Title, Course Duration, Course Fee, Amount of Recommended Course Fee Refund and the Total Amount of Recommended Course Fee Refund) in an Excel/Word file as supplementary document for Education Bureau's processing.",
    },
    label1: {
        header: {
            headerOne: "Statement",
        },
        statement:
            "I have read and understood the Important Notes and Personal Information Collection Statement above.",
        statement2:
            'I understand the approver needs to have an "iAM Smart+" account to submit the application to Education Bureau via this platform direct.',
    },

    errorMsg: {
        // required: "This field is required",
        email: "Please enter the correct email address",
        courseRefund:
            "This field cannot exceed the maximum amount of {{amount}} to be reimbursed",
        lessCourseFee:
            "Amount of Recommended Course Fee Refund should not more than Course Fee",
        numLimit: "Please enter {{limit}}",
        numLimit2: "Total Amount not exceeding {{limit}}",
        number: "Please enter the number in the correct format",
        checkRead:
            "Please read the Important Notes above and select the checkbox",
        checkIsRequired:
            "Please read the Important Notes and Personal Information Collection Statement above and select the checkbox.",
        minDigit: "This field need at least {{min}} digits",
        checkSchoolHead:
            "If the School Head applies for course fee refund, the application must be signed by the Supervisor",
        checkApproverRole:
            "Please refer to the selected position above and select the corresponding approver",
        length: {
            note: "Length must not exceed 50 characters",
            note1: "Length must not exceed 100 characters",
            note2: "Length must not exceed 200 characters",
            note3: "Length must not exceed 1000 characters",
        },
        tel: {
            rule: "Please input a valid 8-digit telephone number",
            digit: "Telephone number must be exactly 8 digits",
        },
        fax: {
            rule: "Please input a valid 8-digit fax number",
            digit: "Fax number must be exactly 8 digits",
        },
        date: {
            rule: "Please input a valid date",
            todayOrBefore: "Please select today or before",
            afterThisDate: "Please select a date after {{targetDate}}",
            age: "The applicant is at least 18 years old at the time of submission。",
        },
    },
};
export default Form014EN;
